module.exports = __webpack_public_path__ + "img/COM TUBETE -mobile.d26bc2e1.png";